<template>
  <div class="grid grid-cols-12 gap-x-10 mt-8 mb-5">
    <div class="col-span-12">
      <div class="flex items-center justify-between">
        <p class="title">기관 정보</p>
        <div v-if="type !== 'info'" class="flex justify-end items-center gap-3">
          <vs-button class="mr-4" color="secondary" type="border" @click="removeCompany">삭제</vs-button>
          <vs-button color="secondary" @click="openPopup">추가</vs-button>
        </div>
      </div>
      <vs-table v-model="selectCompany" @selected="handleSelected" pagination :data="companyList" class="table-list mt-5">
        <template slot="thead">
          <vs-th>No.</vs-th>
          <vs-th v-for="tHead in tableColumns" :key="`head-${tHead.key}`">{{ tHead.head }}</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>{{ indextr + 1 }}</vs-td>
            <vs-td v-for="tBody in tableColumns" :key="`body-${tBody.key}`">{{ data[indextr][tBody.key] }}</vs-td>
          </vs-tr>
          <div></div>
        </template>
      </vs-table>
    </div>
    <div v-if="useDetail" class="col-span-12">
      <div class="flex items-center justify-between">
        <p class="title">{{ detailTitle }}</p>
      </div>
      <div class="mt-5">
        <div class="writeGridContainer">
          <div>
            <search-nav-item-select class="search-item" label="구분" v-model="selectCompany.com_type" :list="comTypes" :readonly="true" />
          </div>
          <div></div>
          <div></div>
          <div>
            <div>{{ detailLabelComName }}</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany.com_name" />
          </div>
          <div v-for="detail in detailTableColumns">
            <div>{{ detail.label }}</div>
            <ml-input class="w-full flex-1" :readonly="true" :value="selectCompany[detail.key]" />
          </div>
        </div>
      </div>
    </div>

    <popup-search-company
      multiple
      :selectId="selectId"
      title="기관명 불러오기"
      :colDatas="[
        { label: 'No.', value: 'id' },
        { label: '구분', value: 'com_type' },
        { label: '기관명', value: 'com_name' },
        { label: '대표자', value: 'com_ceo' },
        { label: '사업장 주소', value: 'com_address' },
      ]"
      v-model="showPopup"
      @handleClickSelect="handleClickSelect"
    />
  </div>
</template>

<script>
import PopupSearchCompany from "@/popup/PopupSearchCompany";
import SearchNavItemSelect from "@/components/nav/SearchNavItemSelect";
import SearchNavStartEnd from "@/components/nav/SearchNavStartEnd.vue";
export default {
  name: "CompanyAddModule",
  components: {
    SearchNavStartEnd,
    SearchNavItemSelect,
    PopupSearchCompany,
  },
  props: {
    title: {
      type: String,
      default: () => {
        return "";
      },
    },
    tableColumns: {
      type: Array,
      default: () => {
        return [
          { head: "구분", key: "com_type" },
          { head: "기관명", key: "com_name" },
          { head: "대표자", key: "com_ceo" },
          { head: "담당자", key: "director" },
          { head: "연락처", key: "phone" },
        ];
      },
    },
    detailTitle: {
      type: String,
      default: () => {
        return "기관 세부 정보";
      },
    },
    detailLabelComName: {
      type: String,
      default: () => {
        return "기관명";
      },
    },
    detailTableColumns: {
      type: Array,
      default: () => {
        return [
          { label: "대표자", key: "com_ceo" },
          { label: "사업자번호", key: "com_number" },
          { label: "주소", key: "com_address" },
          { label: "업태", key: "com_business_class" },
          { label: "담당자", key: "director" },
          { label: "업종", key: "com_business_type" },
          { label: "연락처", key: "phone" },
        ];
      },
    },
    popupTitle: {
      type: String,
      default: () => {
        return "부서(기관) 불러오기";
      },
    },
    value: {
      type: Array,
      default: () => {
        return [];
      },
    },
    useDetail: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "write",
    },
  },
  data() {
    return {
      showPopup: false,
      nav: {
        selects: [
          {
            text: "1",
            value: "1",
          },
        ],
      },
      selectCompany: {},
      companyList: this.value,
      comTypes: [
        {
          text: "본청",
          value: "본청",
        },
        {
          text: "도급",
          value: "도급",
        },
        {
          text: "용역",
          value: "용역",
        },
        {
          text: "위탁",
          value: "본청",
        },
        {
          text: "기타",
          value: "기타",
        },
      ],
    };
  },
  computed: {
    selectId() {
      return this.companyList.map((company) => company.id);
    },
  },
  watch: {
    value(data) {
      this.companyList = this.value;
    },
    companyList: {
      deep: true,
      handler(data) {
        this.$emit("input", data);
      },
    },
  },
  methods: {
    openPopup() {
      this.showPopup = true;
    },
    handleSelected() {
      this.$emit("selected", this.selectCompany);
    },
    handleClickSelect(company) {
      this.companyList = JSON.parse(JSON.stringify(company));
    },
    findCompanyIndex(company) {
      let i = 0;
      for (i = 0; i < this.companyList.length; i++) {
        const com = this.companyList[i];
        if (com.id === company.id) {
          return i;
        }
      }
      return -1;
    },
    removeCompany() {
      if (this.selectCompany && this.selectCompany.id) {
        const index = this.findCompanyIndex(this.selectCompany);
        if (index >= 0) {
          const company = this.companyList[index];
          const list = this.companyList.splice(index, 1);

          this.$emit("remove", company);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.table-list ::v-deep {
  .vs-table-text {
    justify-content: center;
  }

  .vs-table--td {
    text-align: center;
  }
}
.title {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
  position: relative;
  padding-left: 12px;
  &::before {
    content: "";
    width: 8px;
    height: 8px;
    background: #7e72f2;
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: -8px;
    border-radius: 100%;
  }
}
.title-n {
  font-weight: 500;
  font-size: 16px;
  height: 17px;
  line-height: 17px;
}
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.size-search {
  width: 200px;
}
.input-se {
  width: 100%;
  &::v-deep .start-end-title {
    width: 114px;
    font-weight: 500;
    font-size: 14px;
    justify-content: flex-start;
  }
  &::v-deep .mr-2 {
    flex: 1;
    margin-right: 10px !important;
  }
  &::v-deep .mr-2 + .mr-2 {
    margin-right: 0 !important;

    &::before {
      content: "~";
      margin-right: 10px;
    }
  }
  &::v-deep .inline-block {
    width: 100% !important;
  }
}
.vs-table-primary .is-selected {
  background: rgba(126, 114, 242, 0.6) !important;
  color: white;
}
.search-item {
  width: 100% !important;
  margin: 0 !important;
  &::v-deep > div:first-child {
    width: 114px !important;
    font-weight: 500;
    font-size: 14px;
  }
  &::v-deep > div:last-child {
    flex: 1 !important;
    .con-select {
      width: 100%;
    }
  }
}
.upload-img {
  width: 100%;
  height: 318px !important;
  margin-top: 22px;
}
</style>

<style lang="scss">
.none-card {
  box-shadow: none;
  border-radius: 0px;
  display: inline-block;

  .vx-card__body {
    padding: 0px !important;
  }
}

span.up {
  color: #28c76f;
}
span.down {
  color: #ea5455;
}
.vs-table--tbody-table tr:nth-child(2n) {
  background-color: #f9f9f9;
}
</style>
